import React, { useEffect, useState } from 'react'
import {
  // DeviceSliderContainer,
  TrendingTopicsContainer,
  RecentTopicsContainer,
  FavouritesContainer,
  BulletinContainer,
  FreeNavSliderContainer,
  VirtualAgent,
  LaunchPadContainer
} from 'containers'
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'
import { useKendra } from '../../hooks'
import KendraContainer from 'containers/Kendra/KendraSearch'

const SortablePanel = styled.div`
  position: relative;
`

const Handle = styled.span`
  position: absolute;
  left: 8px;
  top: 18px;
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  display: none;
  user-select: none;
  z-index: 2;

  div:hover > & {
    display: block;
  }

  .fa-drag-handle:before {
    content: '\f142 \f142';
    letter-spacing: 2px;
    font-size: 14px;
    opacity: 0.5;
  }
`
const DragHandle = SortableHandle(() => (
  <Handle>
    <FontAwesome name="drag-handle" />
  </Handle>
))

const SortableItem = SortableElement(({ value }) => {
  const components = {
    bulletin: BulletinContainer,
    trending: TrendingTopicsContainer,
    recent: RecentTopicsContainer,
    favourites: FavouritesContainer,
    launch: LaunchPadContainer
  }

  const Component = components[value]
  return (
    <SortablePanel>
      <DragHandle />
      <Component height="300px" />
    </SortablePanel>
  )
})

/**
 * The `Home` component is a SortableContainer that renders a collection of widgets
 * based on the `items` prop and the `isKendraEnabled` state. It uses the `useKendra`
 * hook to determine if Kendra search is enabled, and updates the `widgets` state
 * accordingly.
 * The component then renders the widgets using the `SortableItem` component,
 * which is responsible for rendering the individual widget components.
 *
 * @param {Object} props - The props object containing the following properties:
 * @param {Array<string>} props.items - An array of widget names to be rendered.
 * @param {boolean} props.isKendraEnabled - A boolean indicating whether Kendra search is enabled.
 * @returns {React.ReactElement} The rendered Home component.
 */
const Home = SortableContainer(({ items, ...props }) => {
  const { isKendraEnabled: isKendraSearchEnabled } = useKendra();
  const isKendraEnabled = props.isKendraEnabled || isKendraSearchEnabled

  const renderWidgets = items.map((item, idx) => (
    <Col xs={12} md={6} key={`item-${item}-${idx}`}>
      <SortableItem index={idx} value={item} />
    </Col>
  ))

  return (
    <div>
      <VirtualAgent />
      {isKendraEnabled &&
        // Render Kendra app tree if Kendra is enabled
        <KendraContainer widgets={renderWidgets} {...props} />
      }
      {!isKendraEnabled && (
        <Row>
          {renderWidgets}
        </Row>
      )}
      {/* <DeviceSliderContainer/> */}
      <FreeNavSliderContainer />
    </div>
  )
})

export default Home
